export default __webpack_public_path__ + "static/media/Lianel-Artiles-Dev-CV-Fre.dff81628.pdf";